import { render, staticRenderFns } from "./statAppointRenshuDates2.vue?vue&type=template&id=69cb05ff"
import script from "./statAppointRenshuDates2.vue?vue&type=script&lang=js"
export * from "./statAppointRenshuDates2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports